import axios from 'axios';

async function getCliqueSigner(rpcUrl: string, blockNumber: number) {
  const blockHex = '0x' + blockNumber.toString(16);
  const payload = {
    jsonrpc: '2.0',
    method: 'clique_getSigner',
    params: [ blockHex ],
    id: 1,
  };

  const response = await axios.post(rpcUrl, payload);
  if (response.data.result) {
    return response.data.result;
  } else {
    return '0x0000000000000000000000000000000000000000';
  }
}

export default getCliqueSigner;
